import { useEffect, useRef, useState } from "react";

const WS_BASE = `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws`;

export function useLive(path, onMessage) {
  const [connected, setConnected] = useState(false);
  const cb = useRef(onMessage);
  cb.current = onMessage;
  useEffect(() => {
    if (!path) return undefined;
    let ws = null, ping = null, retry = null, closed = false, delay = 1000;
    const open = () => {
      ws = new WebSocket(`${WS_BASE}/${path}`);
      ws.onopen = () => {
        setConnected(true); delay = 1000;
        ping = setInterval(() => { if (ws.readyState === 1) ws.send("ping"); }, 25000);
      };
      ws.onmessage = (e) => { try { cb.current(JSON.parse(e.data)); } catch { /* ignore */ } };
      ws.onclose = () => {
        setConnected(false); clearInterval(ping);
        if (!closed) { retry = setTimeout(open, delay); delay = Math.min(delay * 2, 15000); }
      };
    };
    open();
    return () => { closed = true; clearTimeout(retry); clearInterval(ping); if (ws) ws.close(); };
  }, [path]);
  return connected;
}

export function useWakeLock(active) {
  const [state, setState] = useState("off");
  useEffect(() => {
    if (!active) return undefined;
    if (!("wakeLock" in navigator)) { setState("unsupported"); return undefined; }
    let lock = null, gone = false;
    const req = async () => {
      try {
        lock = await navigator.wakeLock.request("screen");
        setState("on");
        lock.addEventListener("release", () => { if (!gone) setState("off"); });
      } catch { setState("off"); }
    };
    const onVis = () => { if (document.visibilityState === "visible") req(); };
    req();
    document.addEventListener("visibilitychange", onVis);
    return () => { gone = true; document.removeEventListener("visibilitychange", onVis); if (lock) lock.release().catch(() => {}); };
  }, [active]);
  return state;
}
